import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fbPageView, fbPixelId } from './services/facebook-pixel'

export const FacebookPixel = () => {
  const [loaded, setLoaded] = useState(false)
  const location = useLocation()

  // Load the script once
  useEffect(() => {
    // Initialization guard
    if (window.fbq) {
      setLoaded(true)
      return
    }

    const script = document.createElement('script')
    script.src = '/scripts/facebook-pixel.js'
    script.async = true
    script.dataset.pixelId = fbPixelId

    script.onload = () => setLoaded(true)

    document.body.appendChild(script)
  }, [])

  // Fire page events on route changes
  useEffect(() => {
    if (!loaded) return

    fbPageView()
  }, [location.pathname, loaded])

  return null // no DOM needed
}
